import { useState, useEffect } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";
import { filtersToQueryParams } from "utils/misc";

export default function useAdminUserList(filters = {}) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchAdminUsers() {
      setLoading(true);
      const { response, data } = await API.admin.fetchUserList(token, filtersToQueryParams(filters));

      if (response.ok) {
        setResult(data);
        setLoading(false);
      } else {
        console.error(data);
      }
    }

    fetchAdminUsers();
  }, [Object.values(filters).join("__")]);

  return {
    loading,
    users: result?.results ?? [],
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.page ?? 0,
  };
}
